module.exports = __webpack_public_path__ + "a8b34dda138d9d8ff7d7d92fac09d50b.png";